import { useContext } from 'react';

import { LaneType } from 'common-types';
import { PERMISSION_KEYS } from 'constants-permissions';
import { UserDataContext } from 'lane-shared/contexts';
import hasPermission from 'lane-shared/helpers/hasPermission';

export function useCanViewAllPmTasks(channelId?: LaneType.UUID): boolean {
  const { user } = useContext(UserDataContext);

  return (
    Boolean(user?.isSuperUser) ||
    hasPermission(
      user?.roles,
      [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_PM_TASK_VIEW],
      channelId,
      false
    )
  );
}
